/* global swal:false */
(function () {
  "use strict";

  angular
    .module("admin.communities.post_hidden", [
      "admin.communities.post_hidden.service",
    ])
    .controller("CommunitiesPostsHiddenCtrl", CommunitiesPostsHiddenCtrl);

  /** @ngInject */
  function CommunitiesPostsHiddenCtrl(
    $stateParams,
    $state,
    CommunitiesPostsHiddenService
  ) {
    var vm = this;
    vm.items = [];

    function reloadPagination() {
      vm.totalUsers = 0;
      vm.oldPage = 0;
      vm.usersPerPage = 25;
      vm.currentPage = 25;
      vm.first = true;
      vm.totalItems = 0;
      vm.pagination = {
        current: 1,
      };
    }

    reloadPagination();

    load(1);

    function load(pageNumber) {
      if (pageNumber === 1) {
        vm.pagination.current = 1;
      }
      if (!vm.first) {
        vm.currentPage = pageNumber * 25;
        vm.oldPage = vm.currentPage - 25;
      } else {
        vm.first = false;
      }
      CommunitiesPostsHiddenService.list(vm.oldPage, 25).then(function (
        result
      ) {
        if (vm.totalItems === 0) {
          vm.totalItems = result.ct;
        }

        vm.items = result.results;
      });
    }

    vm.pageChanged = function (newPage) {
      load(newPage);
    };

    vm.showDescription = function (item) {
      $("#myModal").modal("show");
      $("#myModal").on("shown.bs.modal", function () {
        $("#description").text(item);
      });
    };

    vm.edit = function (item) {
      $state.go("admin.posts.edit", {
        id: item.id,
        returnUrl: "/admin/communities/post_hidden",
      });
    };

    vm.comments = function (item) {
      $state.go("admin.posts.comments", {
        parentId: item.id,
        returnUrl: "/admin/communities/post_hidden",
      });
    };

    vm.delete = function (item) {
      swal(
        {
          title: "Are you Sure?",
          text: "",
          type: "warning",
          showCancelButton: true,
          closeOnConfirm: true,
          closeOnCancel: true,
          animation: "slide-from-top",
        },
        function (isConfirm) {
          if (isConfirm) {
            if (item["ts-p"] !== undefined || item["ts-p"] !== null) {
              PostsAdminService.update(item.id, { "ts-p": null }).then(
                function () {
                  PostsAdminService.remove(item.id).then(function () {
                    $state.reload();
                  });
                }
              );
            } else {
              PostsAdminService.remove(item.id).then(function () {
                $state.reload();
              });
            }
          } else {
            return;
          }
        }
      );
    };
  }
})();
